// Card de ACCIÓN para carruseles y grillas de pickers: "Ver más" al final de
// un carrusel, "Subir pose" al principio de la grilla. Es una card más entre
// las de contenido — misma medida, mismo radio, mismo hover— y por eso el
// tamaño lo fija el caller con `className`.
//
// Antes vivía como `VerMasCard`; se generalizó cuando la card de subir pose
// pasó a usar este mismo diseño (dashed brand-primary → card sobria), para no
// tener dos estilos distintos de "card que no es contenido".

import React from 'react';
import { ChevronRight } from 'lucide-react';

export interface AccionCardProps {
  onClick: () => void;
  /** Medida de la card — debe matchear la de las otras del carrusel/grilla. */
  className?: string;
  label?: string;
  /** Texto chico debajo del label (ej. "12 fondos"). */
  sublabel?: string;
  /** Ícono del círculo. Default: chevron (caso "Ver más"). */
  icon?: React.ReactNode;
  /** Spinner + card deshabilitada mientras la acción corre. */
  loading?: boolean;
  loadingLabel?: string;
  disabled?: boolean;
}

export const AccionCard: React.FC<AccionCardProps> = ({
  onClick,
  className = '',
  label = 'Ver más',
  sublabel,
  icon,
  loading = false,
  loadingLabel = 'Subiendo…',
  disabled = false,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled || loading}
    className={`${className} group rounded-xl md:rounded-[13px] border-2 border-neutral-200 bg-white flex flex-col items-center justify-center gap-2 hover:border-brand-primary disabled:opacity-60 disabled:cursor-not-allowed active:scale-[0.97] transition-colors`}
  >
    <span className="w-11 h-11 rounded-full inline-flex items-center justify-center bg-neutral-100 text-[#3C3C43]/45 group-hover:bg-brand-primary group-hover:text-white group-disabled:group-hover:bg-neutral-100 transition-colors">
      {loading ? (
        <span className="w-5 h-5 rounded-full border-2 border-brand-primary/30 border-t-brand-primary animate-spin" />
      ) : (
        icon ?? <ChevronRight className="w-5 h-5" strokeWidth={2.5} />
      )}
    </span>
    <span className="px-2 text-center">
      <span className="block text-[13.5px] font-semibold leading-tight text-[#3C3C43]/60 group-hover:text-brand-primary transition-colors">
        {loading ? loadingLabel : label}
      </span>
      {sublabel && !loading && (
        <span className="block text-[11.5px] text-[#3C3C43]/45 mt-0.5">
          {sublabel}
        </span>
      )}
    </span>
  </button>
);

export default AccionCard;
